export default "__VITE_PUBLIC_ASSET__cc8d5a62__"